export default __webpack_public_path__ + "static/media/insight_stem.bd7a790f.png";